// Smart Sash Admin Panel - Group Management Page

import React from 'react';
import { Alert, Button, PermissionGate } from '@/components/common';
import {
  GroupTable,
  GroupFormModal,
  GroupDeleteModal,
} from '@/components/group';
import { useGroupManagement } from '@/hooks/useGroupManagement';

export const GroupManagement: React.FC = () => {
  const {
    groups,
    institutions,
    pagination,
    isLoading,
    error,
    currentPage,
    pageSize,
    pageSizeOptions,
    showModal,
    modalMode,
    showDeleteModal,
    groupToDelete,
    formData,
    isSaving,
    setCurrentPage,
    handlePageSizeChange,
    handleCreateClick,
    handleEditClick,
    handleDeleteClick,
    handleSubmit,
    handleDelete,
    handleInputChange,
    closeModal,
    closeDeleteModal,
    clearError,
  } = useGroupManagement();

  return (
    <div className="container-fluid py-4">
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1 className="h3 mb-0">Group Management</h1>
              <p className="text-muted">Manage groups within institutions</p>
            </div>
            <PermissionGate action="group:create">
              <Button variant="primary" icon="fas fa-plus" onClick={handleCreateClick}>
                Add Group
              </Button>
            </PermissionGate>
          </div>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="row mb-3">
          <div className="col-12">
            <Alert variant="danger" dismissible onDismiss={clearError}>
              <i className="fas fa-exclamation-circle me-2"></i>
              {error}
            </Alert>
          </div>
        </div>
      )}

      {/* Groups Table */}
      <div className="row">
        <div className="col-12">
          <GroupTable
            groups={groups}
            institutions={institutions}
            pagination={pagination}
            currentPage={currentPage}
            pageSize={pageSize}
            pageSizeOptions={pageSizeOptions}
            isLoading={isLoading}
            onPageChange={setCurrentPage}
            onPageSizeChange={handlePageSizeChange}
            onEdit={handleEditClick}
            onDelete={handleDeleteClick}
          />
        </div>
      </div>

      {/* Create/Edit Modal */}
      <GroupFormModal
        isOpen={showModal}
        mode={modalMode}
        formData={formData}
        institutions={institutions}
        isSaving={isSaving}
        onInputChange={handleInputChange}
        onSubmit={handleSubmit}
        onClose={closeModal}
      />

      {/* Delete Confirmation Modal */}
      <GroupDeleteModal
        isOpen={showDeleteModal}
        group={groupToDelete}
        isSaving={isSaving}
        onConfirm={handleDelete}
        onClose={closeDeleteModal}
      />
    </div>
  );
};

export default GroupManagement;
